import { render, staticRenderFns } from "./WithAction.vue?vue&type=template&id=c2dd0e70"
import script from "./WithAction.vue?vue&type=script&lang=js"
export * from "./WithAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports